export class Service {
  serviceId: string;
  description: string;

  constructor(serviceId: string, description: string) {
    this.serviceId = serviceId;
    this.description = description;
  }
}
